module.exports = __webpack_public_path__ + "img/ROROCCCO01330466.4d657334.png";